import React from 'react';
import { Eye, FileCode, Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="relative py-12 md:py-24 bg-[#050a0f]" data-id="element-99">
      <div className="container mx-auto px-4" data-id="element-100">
        {/* Header Content - Centered */}
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-16" data-id="element-101">
          <div className="text-[#c9a84c] font-mono text-sm tracking-widest mb-4" data-id="element-102">
            THE UNIQUE MECHANISM
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#c8c0b0]" data-id="element-103">
            The Fractal Player's Map
          </h2>
          <p className="text-lg text-[#c8c0b0]/80 leading-relaxed" data-id="element-104">
            "How To Play The Game" is not a self-help book. It is a deep-dive
            into Fractal Engineering. While others talk about "positive
            thinking," we show you how to identify the hidden code that
            replicates your conflicts.
          </p>
        </div>

        {/* Features Grid - 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-16 max-w-6xl mx-auto" data-id="element-105">
          {[{
          icon: Eye,
          title: 'Dismantle the Mask',
          desc: 'Find out who you truly are behind the name and the body you were assigned (Chapter 1).'
        }, {
          icon: FileCode,
          title: 'Break Soul Contracts',
          desc: 'Identify and dissolve the invisible agreements that keep you stuck in the same tragedies (Chapter 10).'
        }, {
          icon: Zap,
          title: 'Hack the DMT Code',
          desc: 'Understand the simulated reality (Chapter 13) to finally start dictating your own rules.'
        }].map((item, i) => <div key={i} className="bg-[#0a1520] border border-[#c9a84c]/20 p-5 md:p-8 rounded-xl flex flex-col items-center text-center hover:border-[#c9a84c]/40 transition-colors duration-300" data-id="element-106">
              <div className="mb-4 md:mb-6" data-id="element-107">
                <div className="w-12 h-12 rounded-full bg-[#c9a84c]/10 flex items-center justify-center border border-[#c9a84c]/30 shadow-[0_0_15px_rgba(201,168,76,0.1)]" data-id="element-108">
                  <item.icon className="w-6 h-6 text-[#c9a84c]" data-id="element-109" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#c8c0b0] mb-3" data-id="element-110">
                {item.title}
              </h3>
              <p className="text-[#c8c0b0]/60 text-sm leading-relaxed" data-id="element-111">
                {item.desc}
              </p>
            </div>)}
        </div>

        {/* Code Panel - Centered */}
        <div className="relative max-w-2xl mx-auto" data-id="element-112">
          <div className="absolute inset-0 bg-gradient-to-r from-[#00d4ff]/20 to-[#c9a84c]/20 blur-3xl rounded-full opacity-30" data-id="element-113" />
          <div className="relative bg-[#0a1520] border border-[#c8c0b0]/10 p-5 md:p-8 rounded-lg shadow-2xl overflow-hidden" data-id="element-114">
            <div className="flex items-center justify-between mb-4 md:mb-8 border-b border-[#c8c0b0]/10 pb-4" data-id="element-115">
              <span className="font-mono text-[#00d4ff] text-xs" data-id="element-116">
                SYSTEM_ACCESS_GRANTED
              </span>

              <div className="flex gap-2" data-id="element-117">
                <div className="w-2 h-2 rounded-full bg-red-500/50" data-id="element-118" />
                <div className="w-2 h-2 rounded-full bg-yellow-500/50" data-id="element-119" />
                <div className="w-2 h-2 rounded-full bg-green-500/50" data-id="element-120" />
              </div>
            </div>
            <div className="space-y-4 font-mono text-sm" data-id="element-121">
              <div className="text-[#c8c0b0]/50" data-id="element-122">
                {' '}
                // Accessing core files...
              </div>
            </div>
            <div className="text-[#c8c0b0] font-mono mt-4 break-all" data-id="element-123">
              <span className="text-[#c9a84c]" data-id="element-124">const</span> reality ={' '}
              <span className="text-[#00d4ff]" data-id="element-125">new</span> Simulation();
            </div>
            <div className="text-[#c8c0b0] font-mono break-all" data-id="element-126">
              reality.<span className="text-[#f0d080]" data-id="element-127">breakPattern</span>(
              <span className="text-green-400" data-id="element-128">"infinite_loop"</span>);
            </div>
            <div className="text-[#c8c0b0] font-mono" data-id="element-129">
              <span className="text-[#c9a84c]" data-id="element-130">if</span> (player.isAwake) {'{'}
            </div>
            <div className="pl-4 text-[#c8c0b0] font-mono" data-id="element-131">
              fractal.<span className="text-[#f0d080]" data-id="element-132">rewrite</span>();
            </div>
            <div className="text-[#c8c0b0] font-mono" data-id="element-133">{'}'}</div>

            <div className="text-[#00d4ff] mt-6 font-mono typing-effect" data-id="element-134">
              {'>'} Pattern identified.
              <br data-id="element-135" />
              {'>'} Ready to override...
            </div>
          </div>
        </div>
      </div>
    </section>;
}